import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-secondary text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Company Description */}
          <div className="col-span-1">
            <div className="mb-4">
              <img
                src="/logofooter.png"
                alt="De Blauwe Vogel"
                className="w-32 h-32 object-contain"
                onError={(e) => {
                  // Fallback if image is not available
                  const target = e.target as HTMLImageElement;
                  target.src = "/logo-placeholder.svg";
                }}
              />
            </div>
            <p className="text-sm leading-relaxed mb-4">
              REISFAMILIE CARLIER - MEER DAN 400 JAAR ERVARING IN REIZEN. UW BETROUWBARE PARTNER VOOR BEGELEIDE REIZEN EN CRUISES.
            </p>
            <div className="flex space-x-4 mt-4">
              <a 
                href="https://www.facebook.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white hover:text-accent transition duration-300"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.444 7.841h-4.717v-3.103c0-1.159.924-1.159.924-1.159h3.447v-3.579l-4.719-.02c-5.277 0-4.717 4.075-4.717 4.075v3.786h-3.087v3.93h3.087v10.229h5.031v-10.229h3.469l.282-3.93z" />
                </svg>
              </a>
              <a 
                href="https://www.instagram.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white hover:text-accent transition duration-300"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-lg font-bold mb-4 uppercase">Snelle Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/reisaanbod/begeleide-rondreizen" className="hover:text-accent transition duration-300">
                  RONDREIZEN
                </Link>
              </li>
              <li>
                <Link to="/reisaanbod/cruises" className="hover:text-accent transition duration-300">
                  CRUISES
                </Link>
              </li>
              <li>
                <Link to="/reisaanbod/hotels-strand" className="hover:text-accent transition duration-300">
                  HOTELS & STRAND
                </Link>
              </li>
              <li>
                <Link to="/reisaanbod/citytrips" className="hover:text-accent transition duration-300">
                  CITYTRIPS
                </Link>
              </li>
              <li>
                <Link to="/themadagen" className="hover:text-accent transition duration-300">
                  THEMADAGEN
                </Link>
              </li>
              <li>
                <Link to="/cadeaubonnen" className="hover:text-accent transition duration-300">
                  CADEAUBONNEN
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="col-span-1">
            <h3 className="text-lg font-bold mb-4 uppercase">Contact</h3>
            <address className="not-italic">
              <div className="flex items-start mb-3">
                <svg className="h-6 w-6 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <div>
                  <p>LUIKERSTEENWEG 54D</p>
                  <p>B002 - 3800 SINT-TRUIDEN</p>
                </div>
              </div>
              <div className="flex items-center mb-3">
                <svg className="h-6 w-6 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <p>(32) 11 705 500</p>
              </div>
              <div className="flex items-center">
                <svg className="h-6 w-6 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <Link to="/contact" className="hover:text-accent transition duration-300">
                  CONTACT
                </Link>
              </div>
            </address>
          </div>

          {/* Newsletter */}
          <div className="col-span-1">
            <h3 className="text-lg font-bold mb-4 uppercase">Nieuwsbrief</h3>
            <p className="mb-4">
              Schrijf u in voor onze nieuwsbrief en ontvang als eerste onze aanbiedingen.
            </p>
            <Link 
              to="/nieuwsbrief" 
              className="inline-block bg-primary hover:bg-primary-dark text-white font-bold py-2 px-6 rounded transition duration-300"
            >
              INSCHRIJVEN
            </Link>

            <div className="mt-8">
              <img 
                src="/vsr2.png" 
                alt="VSR Certificaat" 
                className="w-20 h-20 object-contain mb-2"
              />
              <p className="text-sm">
                Vergund Reisbureau: Licentie A1011<br />
                BE 0433.888.027
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="mt-12 pt-6 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center text-sm">
          <p>© 2025 DE BLAUWE VOGEL - Reizen is geen job, maar onze passie -<Link to="/privacy" className="ml-2 hover:text-accent transition duration-300">PRIVACY POLICY</Link></p>
          <a 
            href="https://ivmedia.be" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="mt-2 md:mt-0 text-sm hover:text-accent transition duration-300"
          >
            IVMEDIA.BE
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 